'use client';

import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { useReducer } from 'react';
import { trackEvent } from '../google-tag-manager';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';

const clamp = (n: number, min: number, max: number) => Math.min(Math.max(n, min), max);

const pricesByCount: Record<number, string> = {
  1: '£59',
  2: '£59',
  3: '£59',
  4: '£69',
  5: '£69',
  6: '£99',
} as const;

const creditsByCount: Record<number, number> = {
  1: 200,
  2: 200,
  3: 200,
  4: 300,
  5: 300,
  6: 500,
} as const;

const options = [{
  label: 'Just me',
  shortLabel: '1',
  value: 1,
}, {
  label: '2 team members',
  shortLabel: '2',
  value: 2,
}, {
  label: '3 team members',
  shortLabel: '3',
  value: 3,
}, {
  label: '4 team members',
  shortLabel: '4',
  value: 4,
}, {
  label: '5 team members',
  shortLabel: '5',
  value: 5,
}, {
  label: '6+ team members',
  shortLabel: '6',
  value: 6,
}];

const SubscriptionPlans = () => {
  const [count, setCount] = useReducer((_: number, next: number) => clamp(next, 1, options.length), 1);
  const increment = () => setCount(count + 1);
  const decrement = () => setCount(count - 1);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.currentTarget;

    setCount(Number(value));
  };

  const price = pricesByCount[count];
  const credits = creditsByCount[count];

  return (
    <section>
      <div className="bg-white shadow-xl rounded-3xl border border-slate-200 overflow-hidden flex flex-col sm:flex-row sm:flex-wrap">
        <div className="pt-8 pb-6 col-span-3 flex flex-col justify-between gap-6 flex-1">
          <div className="px-8 flex flex-col items-center flex-1 justify-center">
            <h2 className="text-4xl font-medium text-slate-900 text-center">
              Subscription
            </h2>
          </div>

          <div className="px-8">
            <hr />
          </div>

          <div className="px-2 sm:px-4">
            <label className="text-center mb-2 text-slate-500 block font-medium text-sm">
              Select your team size
            </label>

            <div className="flex gap-2">
              <button type="button" className="btn btn-ghost btn-lg btn-square rounded-full" onClick={decrement}>
                <FontAwesomeIcon icon={faMinus} />
              </button>

              <select className="sm:hidden select select-bordered rounded-2xl select-lg flex-1 text-center font-bold" value={count} onChange={handleSelectChange}>
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.shortLabel}
                  </option>
                ))}
              </select>

              <select className="hidden sm:block select select-bordered rounded-2xl select-lg flex-1 text-center font-bold" value={count} onChange={handleSelectChange}>
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

              <button type="button" className="btn btn-ghost btn-lg btn-square rounded-full" onClick={increment}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>

            <div className={`text-slate-600 text-sm italic mt-4 text-center ${!credits ? 'invisible' : ''}`}>
              {credits} SMS credits included free per month
            </div>
          </div>
        </div>

        <div className="bg-slate-50 text-center flex-grow flex-shrink-0 flex flex-col">
          <div className="p-8 flex-1 grid place-items-center">
            <div className="text-center">
              <div className="text-5xl font-bold mb-1">
                {price || 'POA'}
              </div>

              <div className={`text-slate-600 font-medium ${price === undefined ? 'invisible' : ''}`}>
                per month
              </div>
            </div>
          </div>

          <div className="px-8 pb-8">
            <Link
              href="/book-demo"
              className="btn btn-primary btn-lg btn-block rounded-full justify-between gap-8 group"
              onClick={() => {
                trackEvent({
                  event: 'book_demo_click',
                });
              }}
            >
              Book demo

              <FontAwesomeIcon icon={faLongArrowRight} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionPlans;
